// import hooks
import { useState, useCallback } from "react";
import useEventListener from "../../hooks/useEventListener/index.js";
import templateStore from "../../client-store/template.store.js";
/**
 * Returns a online hook
 * @returns {boolean}
 */
export const useOnline = () => {
    const [online, setOnline] = useState(true);
    const _onlineHandler = useCallback(() => {
        setOnline(true);
        templateStore.setOnline(true);
    }, []);
    useEventListener({
        eventName: "online",
        payload: _onlineHandler,
    });
    const _offlineHandler = useCallback(() => {
        setOnline(false);
        templateStore.setOnline(false);
    }, []);
    useEventListener({
        eventName: "offline",
        payload: _offlineHandler,
    });
    return online;
};
export default useOnline;
